import React, { useState } from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { COLLAPSED_DESKTOP_WIDTH, HEIGHT_MOBILE, EXPANDED_DESKTOP_WIDTH, } from './constants';
import { AccountIcon } from '../../atoms';
import { Colours, StackOrder, MediaQueries } from '../../tokens';
import AccountNavOption from './AccountNavOption';
import NavOption from './NavOption';
import LogoWrapper from './LogoWrapper';
const getStyles = createUseStyles({
    nav: {
        position: 'fixed',
        right: 0,
        left: 0,
        bottom: 0,
        height: HEIGHT_MOBILE,
        boxShadow: `3px 0px 15px ${Colours.quarternary}`,
        backgroundColor: Colours.white,
        borderRadius: 4,
        zIndex: StackOrder.globalLayoutNav,
        overflow: 'hidden',
        [MediaQueries.medium]: {
            height: '100%',
            width: COLLAPSED_DESKTOP_WIDTH,
            top: 0,
            right: 'auto',
            paddingBottom: 80,
            zIndex: StackOrder.globalLayoutNav,
            boxShadow: `0px 3px 15px ${Colours.quarternary}`,
        },
        [MediaQueries.large]: {
            transition: 'width 0.3s',
        },
    },
    isExpanded: {
        [MediaQueries.large]: {
            width: EXPANDED_DESKTOP_WIDTH,
        },
    },
    list: {
        padding: 8,
        display: 'flex',
        justifyContent: 'space-around',
        [MediaQueries.medium]: {
            display: 'block',
        },
    },
    icon: {
        color: Colours.sexternary,
    },
    iconSelected: {
        color: Colours.primary,
    },
    content: {
        height: '100vh',
        overflowX: 'auto',
        paddingBottom: HEIGHT_MOBILE,
        [MediaQueries.medium]: {
            paddingBottom: 0,
            paddingLeft: COLLAPSED_DESKTOP_WIDTH,
        },
    },
});
const GlobalLayout = ({ className, optionsList = [], accountName = 'Hummingbird', children, }) => {
    const styles = getStyles();
    const [isExpanded, setIsExpanded] = useState(false);
    return (React.createElement("div", { className: classNames(className) },
        React.createElement("nav", { className: classNames(styles.nav, { [styles.isExpanded]: isExpanded }), onMouseEnter: () => setIsExpanded(true), onMouseLeave: () => setIsExpanded(false) },
            React.createElement("ul", { className: styles.list },
                React.createElement(AccountNavOption, { icon: React.createElement(AccountIcon, { className: styles.icon, size: "large", accountInitial: accountName.charAt(0) }), isExpanded: isExpanded }, accountName),
                optionsList.map((item, index) => (React.createElement(NavOption, { key: item.label, isFirst: index === 0, icon: React.createElement(item.iconElement, { className: classNames(styles.icon, {
                            [styles.iconSelected]: item.selected,
                        }) }), selected: item.selected, disabled: item.disabled, to: item.to, onClick: item.onClick, isExpanded: isExpanded }, item.label)))),
            React.createElement(LogoWrapper, { isExpanded: isExpanded })),
        React.createElement("div", { className: styles.content }, children)));
};
export default GlobalLayout;
//# sourceMappingURL=GlobalLayout.js.map